<form class="flex flex-col gap-4" [formGroup]="form">
  <div class="flex flex-col gap-1">
    <h3 class="!m-0 !font-bold">Campaign Subject</h3>
    <div>
      <div>
        <span>Each entry into the campaign is a </span>
        <span class="font-bold">{{ campaignSubject() }}. </span>
        @if (campaignSubject() !== patientSubject) {
          <span>If a Patient has multiple </span>
          <span class="font-bold">{{ campaignSubject() }}s </span>
          <span
            >entered in the campaign, they will be contacted for each
            separately. Re-entry and Conversions are tracked separately for each
          </span>
          <span class="font-bold">{{ entryScope() }}. </span>
        }
        <span>This affects:</span>
      </div>
      <ul class="list-disc pl-8">
        <li>The reports that can be used to enrol entries.</li>
        <li>The template variables available in each step.</li>
      </ul>
    </div>

    <mat-form-field class="pt-2" subscriptSizing="dynamic">
      <mat-label>Campaign Subject</mat-label>
      <mat-select
        formControlName="scope"
        (selectionChange)="campaignSubjectChange($event)"
      >
        @for (scope of scopes; track scope) {
          <mat-option [value]="scope">{{ scope | titlecase }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex flex-col gap-1" formGroupName="entryResetRules">
    <h3 class="!m-0 !font-bold">Campaign Re-Entry</h3>
    <div>
      <span>How often can a </span>
      <span class="font-bold">{{ entryScope() }} </span>
      <span>re-enter this campaign? </span>
      <pr-campaign-steps-summary [stepSummary]="stepSummary()" />
    </div>

    <div class="flex flex-col gap-4 pt-2">
      <mat-form-field subscriptSizing="dynamic" floatLabel="always">
        <mat-label>Re-entry</mat-label>
        <mat-select
          formControlName="reentryScope"
          placeholder="Don't allow re-entry"
        >
          <mat-option [value]="undefined">Don't allow re-entry</mat-option>
          @for (scope of reentryScopes(); track scope) {
            <mat-option [value]="scope"
              >Track by {{ scope | titlecase }}</mat-option
            >
          }
        </mat-select>
      </mat-form-field>

      @if (multipleEntriesAllowed()) {
        <div class="flex flex-row gap-4">
          <mat-form-field class="flex grow" subscriptSizing="dynamic">
            <mat-label>Minimum time between entries</mat-label>
            <input
              matInput
              type="number"
              min="0"
              formControlName="frequencyCount"
            />
            <mat-icon
              class="opacity-50"
              matSuffix
              matTooltip="A value of 0 means a {{
                entryScope()
              }} can be entered multiple times consecutively, without
                any spacing between entries."
            >
              info</mat-icon
            >
          </mat-form-field>

          <mat-form-field class="flex grow" subscriptSizing="dynamic">
            <mat-select formControlName="frequencyType">
              @for (freq of frequencies; track freq.value) {
                <mat-option [value]="freq.value">
                  {{ freq.displayName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field
          class="flex grow"
          subscriptSizing="dynamic"
          floatLabel="always"
        >
          <mat-label>Max Entries per {{ entryScope() }}</mat-label>
          <input
            matInput
            type="number"
            min="1"
            formControlName="maxEntryCount"
            placeholder="Unlimited"
          />
          @if (form.value.entryResetRules.maxEntryCount) {
            <button
              matSuffix
              mat-icon-button
              matTooltip="Allow unlimited entries"
              (click)="setUnlimitedEntries()"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>

        @if (showEntryTimingWarning()) {
          <pr-information-box>
            <div>
              <span>The current </span>
              <span class="font-bold">minimum time between enrolments </span>
              <span>is </span>
              <span class="font-bold">shorter than </span>
              <span>the expected </span>
              <span class="font-bold">time to complete one entry. </span>
              <span>This could lead to a </span>
              <span class="font-bold">{{ entryScope() }} </span>
              <span
                >being re-entered before a previous entry is has finished.
              </span>
            </div>
          </pr-information-box>
        }
      }
    </div>
  </div>

  <div class="flex flex-col gap-1">
    <h3 class="!m-0 !font-bold">Conversion Tracking</h3>
    <div>
      <span>When converted any remaining steps will be skipped and the </span>
      <span class="font-bold">{{ entryScope() }} </span>
      <span>will no longer be eligible for re-entry into the campaign. </span>
    </div>

    <mat-form-field class="pt-2" subscriptSizing="dynamic" floatLabel="always">
      <mat-label>Conversion Tracking</mat-label>
      <mat-select formControlName="conversionType" placeholder="None">
        @for (type of conversionTypes; track type) {
          <mat-option
            matTooltipPosition="right"
            [value]="type"
            [matTooltip]="type | map: getConversionTypeTooltip"
          >
            {{ type | splitCamel | titlecase }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</form>
